import React from "react";
import { UsersList } from "../components/UsersList";

const UsersPage = () => {
  return <UsersList />;
};

export default UsersPage;
